var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"color--background-main"},[_c('Topmenu'),_c('Leftmenu',{staticStyle:{"height":"calc(var(--doc-height))"}}),_c('v-main',{attrs:{"id":"base-content"}},[_c('div',{staticClass:"overflow-y-auto",staticStyle:{"height":"calc(var(--doc-height) - 78px)"}},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }